import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Icon, Popover, PopoverInteractionKind, Position, Menu, MenuItem } from "@blueprintjs/core";
import _ from "lodash";
import {List} from "immutable";

// Components
import VirtualizedTable from "../../../components/common/virtualized-table";

// Actions
import { getProducts, changeProductStatus } from "../../../actions/products";

class ProductsPage extends Component {

    constructor(props) {
        super(props);

        this.state = {
            productsFilter: ''
        };
    }

    componentDidMount() {
      this.props.getProducts({
          projection: 'product_code name category_labels to_buy is_generic status',
          deleteVirtuals: true
      });
    };

    render() {

        const { products, history } = this.props;
        const { productsFilter } = this.state;

        let tableData = products;

        let statsZone = (
            <div className="row stats-zone" style={{ marginBottom: 20 }} >
                <div className="col-auto">
                    <span className="label "><strong>{ products.size }</strong></span>
                    <span className="handPointer" onClick={ () => this.setState({ productsFilter: '' }) } >
                        <strong>Total</strong>
                    </span>
                </div>
                <div className="col-auto">
                    <span className="label label-primary">{ products.count(product => product.get('status') === 'active') }</span>
                    <span className="handPointer" onClick={ () => this.setState({ productsFilter: 'active' }) } >Activos</span>
                </div>
                <div className="col-auto">
                    <span className="label label-danger">{ products.count(product => product.get('status') === 'inactive') }</span>
                    <span className="handPointer" onClick={ () => this.setState({ productsFilter: 'inactive' }) } >Inactivos</span>
                </div>
            </div>
        );

        // Filters
        switch (productsFilter) {
            case 'active':
                statsZone = (
                    <div className="row stats-zone" style={{ marginBottom: 20 }} >
                        <div className="col-auto">
                            <span className="label ">{ products.size }</span>
                            <span className="handPointer" onClick={ () => this.setState({ productsFilter: '' }) } >
                                Total
                            </span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-primary">
                                <strong>{ products.count(product => product.get('status') === 'active') }</strong>
                            </span>
                            <span className="handPointer" onClick={ () => this.setState({ productsFilter: 'active' }) } >
                                <strong>Activos</strong>
                            </span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-danger">{ products.count(product => product.get('status') === 'inactive') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ productsFilter: 'inactive' }) } >Inactivos</span>
                        </div>
                    </div>
                );
                tableData = products.filter( product => product.get('status') === 'active' );
                break;
            case 'inactive':
                statsZone = (
                    <div className="row stats-zone" style={{ marginBottom: 20 }} >
                        <div className="col-auto">
                            <span className="label ">{ products.size }</span>
                            <span className="handPointer" onClick={ () => this.setState({ productsFilter: '' }) } >
                                Total
                            </span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-primary">{ products.count(product => product.get('status') === 'active') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ productsFilter: 'active' }) } >Activos</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-danger">
                                <strong>{ products.count(product => product.get('status') === 'inactive') }</strong>
                            </span>
                            <span className="handPointer" onClick={ () => this.setState({ productsFilter: 'inactive' }) } >
                                <strong>Inactivos</strong>
                            </span>
                        </div>
                    </div>
                );
                tableData = products.filter( product => product.get('status') === 'inactive' );
                break;
            default :
                break;
        }

        // Products Table
        let tableSettings = {
            sortable: true,
            filterable: true,
            defaultSortFields: [],
            defaultSortDirections: ['asc'],
            height: 650,
            rowHeight: 40,
            strippedRows: false
        };
        let tableColumns = {
            product_code: {
                title: 'Código',
                columnType: 'function',
                dataField: ['_id', 'product_code'],
                width: 100,
                style: {},
                sortable: true,
                sortableIndex: 1,
                filterable: true,
                filterableIndex: 1,
                nodeContent: (value) => {
                    return <Link to={ '/productos/' + value[0] }>{ value[1] }</Link>
                }
            },
            name: {
                title: "Nombre",
                columnType: 'function',
                dataField: ['_id', 'name'],
                width: 200,
                style: {},
                sortable: true,
                sortableIndex: 1,
                filterable: true,
                filterableIndex: 1,
                nodeContent: (value) => {
                    return <Link to={ '/productos/' + value[0] }>{ value[1] }</Link>
                }
            },
            category_labels: {
                title: "Categorias",
                columnType: 'function',
                dataField: 'category_labels',
                width: 200,
                style: {},
                sortable: false,
                filterable: true,
                nodeContent: (category_labels) => {
                    category_labels = category_labels && category_labels.map( (category, i) => {
                        return i < category_labels.length -1 ? category + ', ' : category;
                    });

                    return category_labels;
                }
            },
            to_buy: {
                title: "¿Producto comprable?",
                columnType: 'boolean',
                dataField: 'to_buy',
                width: 200,
                style: {},
                sortable: false,
                filterable: false
            },
            is_generic: {
                title: "¿Producto genérico?",
                columnType: 'boolean',
                dataField: 'is_generic',
                width: 200,
                style: {},
                sortable: false,
                filterable: false
            },
            status: {
                title: "Estado",
                columnType: 'function',
                dataField: 'status',
                width: 100,
                style: {},
                sortable: false,
                filterable: false,
                nodeContent: (value) => {
                    let data = value === 'active'
                        ? { badgeColor: 'primary', value: 'activo' }
                        : value === 'inactive'
                            ? { badgeColor: 'danger', value: 'inactivo' }
                            : { badgeColor: 'info', value };

                    return (
                        <div>
                            <span className={'badge badge-' + data.badgeColor}>
                                {_.capitalize(data.value)}
                            </span>
                        </div>
                    );
                }
            },
            actions: {
                title: '',
                columnType: 'function',
                dataField: ['_id', 'status'],
                width: 30,
                style: { alignItems: 'center', maxWidth: 30 },
                sortable: false,
                filterable: false,
                nodeContent: (value) => {
                    const popoverContent = (
                        <Menu>
                            <MenuItem icon="eye-open" text="Ver detalle" onClick={ () => history.push('/productos/' + value[0])} />
                            { value[1] === 'active'
                                ? <MenuItem onClick={ () => this.props.changeProductStatus(value[0], 'inactive') } icon="eye-off" text="Desactivar" />
                                : value[1] === 'inactive'
                                    ? <MenuItem onClick={ () => this.props.changeProductStatus(value[0], 'active') } icon="eye-off" text="Activar" />
                                    : null
                            }
                        </Menu>
                    );

                    return (
                        <div>
                            <Popover
                                content={popoverContent}
                                interactionKind={PopoverInteractionKind.CLICK}
                                position={Position.LEFT_BOTTOM}
                            >
                                <Icon
                                    className="icon-custom"
                                    title={false}
                                    icon={'more'}
                                    iconSize={18}
                                    color="#183650"
                                />
                            </Popover>
                        </div>
                    );
                }
            }
        };

        return (
            <div id="page-wrapper" className="gray-bg">
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col d-flex align-items-center">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                Configuración
                            </li>
                            <li className="breadcrumb-item active">
                                <strong>Productos</strong>
                            </li>
                        </ol>
                    </div>
                    <div className="col d-flex align-items-center justify-content-end">
                        <div className="title-action">
                            <button className="btn btn-primary" onClick={ () => history.push('/productos/nuevo') } > <Icon icon="insert"/>Producto</button>
                        </div>
                    </div>
                </div>
                <div className="wrapper wrapper-content">
                    { statsZone }
                    <div className="row">
                        <div className="col">
                            <div className="ibox">
                                <div className="ibox-content">
                                    <VirtualizedTable
                                        tableSettings={tableSettings}
                                        tableColumns={tableColumns}
                                        tableData={tableData}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    // Reducers
    const productsReducer = state.products;

    // Products
    let products = productsReducer.get('payload') || List([]);

    if (!(products instanceof List)) {
        products = List([]);
    }

    return {
        products
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getProducts: (query) => dispatch(getProducts(query)),
        changeProductStatus: (productId, status) => dispatch(changeProductStatus(productId, status))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductsPage);


// WEBPACK FOOTER //
// ./src/containers/configuration/products/ProductsPage.js